<template>
  <b-pagination
    size="sm"
    :hide-goto-end-buttons="true"
    :prev-text="'< ' + $t('pagination.prev')"
    :next-text="$t('pagination.next') + ' >'"
    :total-rows="total"
    :per-page="perPage"
    v-bind:value="value"
    v-on:input="onInput"
  ></b-pagination>
</template>


<script>
export default {
  name: "pagination",
  props: {
    total: Number,
    perPage: Number,
    value: Number,
  },
  methods: {
    onInput (value) {
      this.$emit('input', value);
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        pagination: {
          prev: "Prev",
          next: "Next",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
ul ::v-deep li {
  margin-right: 0.5rem;
}

ul ::v-deep li:first-child .page-link,
ul ::v-deep li:last-child .page-link {
  border: none;
  white-space: nowrap;
}

ul ::v-deep li.page-item.active .page-link {
  background-color: $corp-color2;
  border-color: $corp-color2;
}

ul ::v-deep li a.page-link {
  color: $text-main-color;

  &:hover {
    color: $text-main-color;
  }
}
</style>
